import { useEffect, useState } from 'react';
import type { Location, NavigateFunction } from 'react-router-dom';
import { CHAT_NAV_ENABLED } from '../../../../lib/chatNavEnabled';

export type TrainerDashboardSection = 'members' | 'library' | 'chat' | 'control';

function resolveTrainerSection(saved: string | null): TrainerDashboardSection | null {
  if (saved === 'members' || saved === 'library' || saved === 'control') return saved;
  if (saved === 'chat') return CHAT_NAV_ENABLED ? 'chat' : 'members';
  return null;
}

export function useTrainerDashboardNavigation(location: Location, _navigate: NavigateFunction) {
  const [activeSection, setActiveSection] = useState<TrainerDashboardSection>(() => {
    try {
      const saved = localStorage.getItem('trainer_dashboard_active_section');
      return resolveTrainerSection(saved) ?? 'members';
    } catch (error) {
      console.error('Error loading saved active section:', error);
    }
    return 'members';
  });

  useEffect(() => {
    try {
      localStorage.setItem('trainer_dashboard_active_section', activeSection);
    } catch (error) {
      console.error('Error saving active section:', error);
    }
  }, [activeSection]);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/library')) {
      setActiveSection('library');
    } else if (path.includes('/chat')) {
      setActiveSection(CHAT_NAV_ENABLED ? 'chat' : 'members');
    } else if (path.includes('/control-centre')) {
      setActiveSection('control');
    }
  }, []);

  const onSectionSelect = (id: TrainerDashboardSection) => {
    if (id === 'chat' && !CHAT_NAV_ENABLED) {
      setActiveSection('members');
      return;
    }
    setActiveSection(id);
  };

  return { activeSection, setActiveSection, onSectionSelect };
}
